import React, { useEffect } from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import styled from 'styled-components';
import { useLocation, useNavigate } from 'react-router-dom';

const StyledContainer = styled(Container)`
  font-family: Montserrat, sans-serif;
  color: rgba(41, 37, 97, 1);
  background: rgb(234, 222, 208);
  padding: 20px 13%;
  text-align: center;
  border-radius: 2px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 34px;
  font-weight: 700;
  font-family: Montserrat, sans-serif;
  padding: 30px 0px;
  color: #292561;
  text-align: left;
`;

const DescriptionText = styled.p`
  font-size: 20px;
  color: #292561;
  margin-top: 10px;
  font-weight: 500;
  text-align: left; 
`;

const Text = styled.p`
  font-size: 20px;
  color: #292561;
  margin-top: 0px; 
  text-align: left; 
  font-weight: 500;
`;

const StyledSubmitButton = styled(Button)`
  background-color: #B01116;
  max-width: fit-content;
  border-radius: 25px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  font-size:20px;
  color: white;
  margin-top: 20px;
  text-align: left;
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
`;

const ContactLink = styled.a`
    color: #1b1464;
    text-decoration: none;
    &:hover {
        color: #0055a5;
    }
`;

const EmailLink = styled.a`
    color: #1b1464;
    text-decoration: none;
    &:hover {
        color: #0055a5;
    }
`;

const scrollToElement = (id) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
};

export default function PaymentFailed() {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = () => {

    if (location.pathname === '/success' || location.pathname === '/failed') {
      navigate('/home'); // Navigate to home if on those pages
    } else {
      scrollToElement('claim'); // Scroll to claim section otherwise
    }
  };

  useEffect(() => {
    // Scroll to the failed section when this component is loaded
    if (location.pathname === '/failed') {
      scrollToElement('failed');
    }
  }, [location.pathname]);

  return (
    <StyledContainer fluid id='failed'>
      <Row>
        <Col>
          <Title>Payment Unsuccessful.</Title>
        </Col>
      </Row>
      <Row>
        <Col>
          <DescriptionText>
            Paki-ulit ang proseso o gumamit ng ibang paraan ng pagbabayad para ma-renew ang iyong policy.
          </DescriptionText>
          <Text>Kung patuloy na nagkakaproblema ang payment, kontakin ang BPI MS Helpline sa <EmailLink href="mailto:help@bpims.com">helpline@bpims.com</EmailLink> o <ContactLink href="tel:+63288409000">(+632) 8840 9000</ContactLink>.</Text>
        </Col>
      </Row>
      <Row>
        <Col>
          <ButtonContainer>
            <StyledSubmitButton
              className="btn-submit me-2"
              variant="danger"
              type="button"
              onClick={handleNavigate}
            >
              TRY AGAIN
            </StyledSubmitButton>
          </ButtonContainer>
        </Col>
      </Row>
    </StyledContainer>
  );
}
